import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { CommonsService } from 'src/app/services/commons.service';
import { EntitiesService } from 'src/app/services/entities.service';
import { SigninService } from 'src/app/services/signin.service';
import { trigger, style, animate, transition } from '@angular/animations';
import { MatDialogConfig } from '@angular/material/dialog';
import { WarningTermsPolityComponent } from 'src/app/components/modals/warning-terms-polity/warning-terms-polity.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-signin-scf',
  templateUrl: './signin-scf.component.html',
  styleUrls: ['./signin-scf.component.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(1300, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class SigninSCFComponent implements OnInit {

  signForm: UntypedFormGroup;
  ss = sessionStorage;
  show = this.ss.getItem('form') ? this.ss.getItem('form') : '1';
  key: string;
  wrongPass: boolean;
  type = 'password';
  squals = true;
  showProgress = false;
  showProgressConsumer = false;
  formatInvalid: boolean;
  receptionMessage: string;
  country: string;
  language: string;
  param = [];
  saveInfor: any;
  showTerms = false; // inicializar a falso -------------------------------------------------------------------------------------------------
  data: any;
  startMessage = '¡Bienvenido a Akana!';
  buttonName = 'Iniciar sesión';
  checkedTerms: boolean;
  firstCall = true;
  code = 200;
  validPassTwo = true;

  constructor(private rc: ReCaptchaV3Service, private f: UntypedFormBuilder, private r: Router, private cs: CommonsService, private sign: SigninService, private se: EntitiesService, private snackBar: MatSnackBar, private modal: MatDialog) { }

  ngOnInit() {
    this.ss.removeItem('form_sign');
    this.getKey();
    this.cs.firstChargePage('Sign In', 'Inicion de sesion Santander consumer', 'funnel');
    this.cs.eventsAnalitics('visit screen', 'content', 'SigninSCF');
    this.createForm();
    sessionStorage.removeItem('globalSCF');
    this.language = sessionStorage.getItem('language');
    this.country = sessionStorage.getItem('country') || 'ES';
  }


  /**
   * recupera una clave que se usa para el google captcha
   */
  getKey = () => {
    if (!sessionStorage.getItem('k_ca')) {
      this.sign.getCaptchaKey().subscribe((key: any) => {
        sessionStorage.setItem('k_ca', key.gsv || key);
        sessionStorage.setItem('country', key.Country);
        if (key.Language) {
          sessionStorage.setItem('language', key.Language);
        }
        this.key =  key.gsv || key;
      });
    } else {
      this.key = sessionStorage.getItem('k_ca');
    }
  }

  createForm = () => {
    this.signForm = this.f.group({}, {});
    this.signForm.addControl('dni', new UntypedFormControl(this.getValuesForm('dni', 's'), [Validators.required]));
    this.signForm.addControl('password_scf', new UntypedFormControl(this.getValuesForm('password_scf', 's'), [Validators.required, Validators.minLength(6)]));
    // this.signForm.addControl('termsAndConditions', new FormControl(this.getValuesForm('termsAndConditions', 'b') || this.readTermsAndConditions(), [Validators.required]));
    // this.signForm.addControl('ofers', new FormControl(this.getValuesForm('ofers', 'b')));
    this.checkDocument();
  }

  /**
  * recupera valor del objeto del formulario en caso de que se vaya a otra vista
  * @param name: string nombre del objeto form
  * @param type: string b -> boolean, s -> string
  */
  getValuesForm = (name: string, type: string) => {
    if (type === 's') {
      return this.saveInfor ? this.saveInfor[name] : this.checkFormSession() !== null ? this.checkFormSession()[name] : '';
    } else if (type === 'b') {
      return this.saveInfor ? this.saveInfor[name] : this.checkFormSession() ? this.checkFormSession()[name] : false;
    }
  }

  /**
   * si parsea la sesion guardada en el caso de que sean 
   */
  checkFormSession = (): any => {
    return this.sessionNullOrUndefinedString() ? JSON.parse(this.ss.getItem('signinSCF')) : null;
  }

  /**
   * Comprueba que la sesion guardada no sea un null o undefined string
   */
  sessionNullOrUndefinedString = () => {
    return this.ss.getItem('signinSCF') && this.ss.getItem('signinSCF') !== 'undefined'
      && this.ss.getItem('signinSCF') !== 'null';
  }


  /**
   * lee si hay algun termino y c
   */
  readTermsAndConditions() {
    if (sessionStorage.getItem('terms') && sessionStorage.getItem('polity')) {
      this.checkedTerms = false;
      return true;
    } else {
      this.checkedTerms = true;
      return false;
    }
  }

  openWarmModal() {
    if (this.readTermsAndConditions()) {
      this.cs.eventsAnalitics('click', 'Aceptar terminos y condiciones de uso', 'terms');
      return;
    } else {
      if (!this.saveInfor && this.sessionNullOrUndefinedString()) {
        this.saveInfor = JSON.parse(this.ss.getItem('signinSCF'));
      }
      this.ss.setItem('signinSCF', JSON.stringify(this.saveInfor));

      const modalConfig = new MatDialogConfig();
      modalConfig.data = {signin: true};
      modalConfig.width = '320px';
      modalConfig.id = 'modal-info';
      modalConfig.maxWidth = '500px';
      this.modal.open(WarningTermsPolityComponent, modalConfig);
      this.checkedTerms = true;
    }
  }

  /**
   * recupera una ruta y te lleva a ella
   * @param r: string;
   */
  goToUrl = (r: string, optional?: string) => {
    this.cs.eventsAnalitics('click', 'SIGN-IN', 'signinSCF');
    if (r === 'terms-conditions?signin=true' || r === 'privacy-polity' && this.show === '2') {
      this.ss.setItem('login_polity', '1');
      this.ss.setItem('form', this.ss.getItem('form') || this.show);
      if (!this.saveInfor && this.sessionNullOrUndefinedString()) {
        this.saveInfor = JSON.parse(this.ss.getItem('signinSCF'));
      }
      this.ss.setItem('signinSCF', JSON.stringify(this.saveInfor));
      r = (this.country) + '/' + r;
    }
    if (this.ss.getItem('form') === '1') {
      this.ss.removeItem('form');
    }
    if (optional === 'inv') {
      this.removeTermsAndPolity();
    }
    this.r.navigateByUrl(r);
  }

  /**
   * Muestra la password al mantenerla pulsada
   * @param num: number
   */
  showPass = (num: number) => {
    if (num === 1) {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }

  analiticsGoogle = () => {
    if (!this.signForm.get('ofers').value) {
      this.cs.eventsAnalitics('click', 'Aceptar ofertas y promociones', 'signin');
    }
  }

  /**
   * comprueba que es correcto el filtro propuesto del captcha
   * @param data: any
   * @param step: number
   */
  recaptchaCheck = (data, step) => {
    this.rc.execute(this.key, 'login', (token) => {
      this.successCaptcha(data, token, step);
    }, { useGlobalDomain: true });
  }

  successCaptcha = (data, token, step) => {
    this.receptionMessage = null;
    switch (step) {
      case 4:
        this.sign.signInSCF(data, token).subscribe((d: any) => {
          this.showProgress = false;
          switch (d.Code) {
            case 300:
              this.ss.setItem('t', d.Token);
              if (d.TyCS) {
                this.getEntities(d.Token, 'Inicio Santander Consumer');
              } else {
                this.goToTyC();
              }
              break;
            case 401:
              this.receptionMessage = 'Alguno de los campos introducidos no es correcto';
              break;
            // case 402:
            //   this.data = [d.Hash, d.Channel];
            //   this.login(7);
            //   break;
            case 403:
              this.receptionMessage = d.Message;
              break;
            case 200:
              if (d.TyCS) {
                this.sign.globalPosition(d.Token).subscribe((c: any) => {
                  this.ss.setItem('t', c.Token);
                  sessionStorage.setItem('_k', this.cs.encrypt(c));
                  sessionStorage.removeItem('signinSCF');
                  this.cs.setKpi(c);
                  this.cs.eventsAnalitics('conversion', 'Informe recuperado correctamente', 'signin');
                  this.r.navigateByUrl('global-position');
                });
              } else {
                this.ss.setItem('t', d.Token);
                sessionStorage.setItem('globalSCF', 'true');
                this.goToTyC();
              }
             
              break;
          }
        });
        break;
      case 7:
        this.sign.termsAndConditions(data, token).subscribe((d: any) => {
          this.ss.setItem('t', d.Token);
          this.getEntities(d.Token, 'Inicio sesion con usuario de santander consumer');
        });
        break;
    }
  }

  login = (n: number) => {
    if (this.signForm.invalid || !this.validPassTwo) {
      return;
    }
    let body = null;
    this.showProgress = true;
    this.receptionMessage = '';
    switch (n) {
      case 4:
        body = {
          IdentificationNumber: this.signForm.get('dni').value,
          Password: this.signForm.get('password_scf').value
        };
        this.recaptchaCheck(body, 4);
        break;
      case 7:
        body = {
          IdentificationNumber: this.data[0],
          Channel: this.data[1],
          CentroId: 0,
          TyCS: this.signForm.get('termsAndConditions').value,
          PolPri: this.signForm.get('ofers').value,
          Country: this.country,
          Language: this.language + '_' + this.language.toUpperCase()
        };
        this.recaptchaCheck(body, 7);
        break;
    }
  }

  private checkDocument = () => {
    const letras = 'TRWAGMYFPDXBNJZSQVHLCKET';
    this.signForm.valueChanges.subscribe(d => {
      this.saveInfor = d;
      if (d.dni && /^(\d{8})([A-Za-z])$/.test(d.dni.toLowerCase())) { // NIF
        if (letras.split('')[+d.dni.substring(0, 8) % 23].toLowerCase() === d.dni.split('')[d.dni.length - 1].toLowerCase()) {
          this.signForm.setErrors(null);
          this.formatInvalid = false;
        } else {
          this.signForm.setErrors({ formatNotValid: false });
          this.formatInvalid = true;
        }
      } else if (d.dni && /^([ABCDEFGHJKLMNPQRSUVWabcdefghjklmnpqrsuvw])(\d{7})([0-9A-Ja-j])$/.test(d.dni.toLowerCase())) { // CIF
        this.signForm.setErrors(null);
        this.formatInvalid = false;
      } else if (d.dni && /^[XYZxyz]\d{7,8}[A-Za-z]$/.test(d.dni.toLowerCase())) { // NIE
        this.signForm.setErrors(null);
        this.formatInvalid = false;
      } else {
        this.signForm.setErrors({ formatInvalid: true });
        this.formatInvalid = true;
      }
    });
  }

  private getEntities = (t, d) => {
    this.se.getTink(t).subscribe(data => window.location.href = data);
  }

  private goToTyC = () => {
    this.ss.setItem('signinSCF', JSON.stringify(this.saveInfor));
    this.r.navigateByUrl('terms?scf=true');
  }

  removeTermsAndPolity = () => {
    this.ss.removeItem('terms');
    this.ss.removeItem('polity');
  }
}
